import React, { useEffect, useState } from 'react'
import { useHistory, withRouter, useParams } from 'react-router-dom';
import { NavDropdown } from 'react-bootstrap';
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";
import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";
function HierarchyNavMenu(props) {
    const history = useHistory();
    const { userId } = useParams();
    const { bookVO } = props;
    const [state, setState] = useState({ groupedSectionData: {}, rootNodes: [] });
    useEffect(() => {
        if (props.sectionVOList) {
            if (props.sectionVOList !== undefined) {
                let rootNodes = props.sectionVOList.filter(x => x.entryNodeParentId === "-999")
                var mappedData = groupArrayOfObjects(props.sectionVOList, "entryNodeParentId")
                for (let i = 0; i < rootNodes.length; i++) {
                    rootNodes[i] = frameTree(rootNodes[i], mappedData)
                }
                setState({ ...state, rootNodes: rootNodes, groupedSectionData: mappedData })
            }
        }
    }, [props.sectionVOList])
    const frameTree = (node, parentMappedSections) => {
        if (node.isParent === "false") {
            return node;
        }
        else {
            if (parentMappedSections[node.entryNodeIdRef] === undefined) {
                return null;
            } else {
                let childSectionVOList = parentMappedSections[node.entryNodeIdRef];
                childSectionVOList = Array.isArray(childSectionVOList) ? childSectionVOList : [childSectionVOList];
                for (let i = 0; i < childSectionVOList.length; i++) {
                    let child = frameTree(childSectionVOList[i], parentMappedSections);
                    if (child !== undefined || child !== null) {
                        if (node.childSections !== undefined) {
                            node.childSections.push(childSectionVOList[i]);
                        } else {
                            if (Array.isArray(node.childSections)) {
                                node.childSections.push(childSectionVOList[i]);
                            } else {
                                node.childSections = [childSectionVOList[i]];
                            }
                        }
                    }
                }
                node.childSections = childSectionVOList;
                return node;
            }
        }
    }
    const groupArrayOfObjects = (list, key) => {
        return list.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };
    const handleChariotDown = (e) => {
        let chariotDown = document.querySelector('#' + e.currentTarget.id + ' ' + '.FaAngleDown_rt');
        let chariotRight = document.querySelector('#' + e.currentTarget.id + ' ' + '.FaAngleRight_rt');
        let chariotDownId = document.querySelector('#' + e.currentTarget.id + ' ' + '.FaAngleDown_rt');
        if (chariotDownId.style.display == "none") {
            chariotRight.style.display = 'none';
            chariotDown.style.display = 'block';
        }
        else {
            chariotRight.style.display = 'block';
            chariotDown.style.display = 'none';
        }
    }
    const handleChapterSelection = (e) => {
        var entryNodeFileRef = e.currentTarget.getAttribute("entryNodeFileRef")
        if (entryNodeFileRef !== null && entryNodeFileRef !== "-999") {
            let chpId = entryNodeFileRef.split(".")[0]
            var entryNodeIdRef = e.currentTarget.getAttribute("entrynodeidref")
            if (entryNodeIdRef !== undefined) {
                let secId = entryNodeFileRef.split("#")[1]
                if (secId !== undefined)
                    history.push(`/read/users/${userId}/books/${bookVO.bookISBN}/${chpId}#${secId}`);
                else
                    history.push(`/read/users/${userId}/books/${bookVO.bookISBN}/${chpId}`);
            } else
                history.push(`/read/users/${userId}/books/${bookVO.bookISBN}/${chpId}`);
        }
    }
    const NavTocNode = (node) => {
        if (node === undefined || node === null) { return <span></span> }
        const nestedNode = (node.childSections || []).map(section => { return NavTocNode(section) });
        if (node.isParent === "false") {
            return (
                <NavDropdown.Item href="">
                    <span data-testid={`node_${node.entryNodeIdRef}`} node={node} entryNodeFileRef={node.entryNodeFileRef} entryNodeIdRef={node.entryNodeIdRef} onClick={handleChapterSelection}>
                        {node.entryNodeTitle}
                    </span>
                </NavDropdown.Item>
            )
        }
        return (
            <DropdownSubmenu href={localStorage.getItem("BASE_URL")}
                title={
                    <span style={{ width: '100%', display: 'inline-block', whiteSpace: 'initial' }}>
                        <span node={node} entryNodeFileRef={node.entryNodeFileRef} entryNodeIdRef={node.entryNodeIdRef} onClick={handleChapterSelection}>
                            {node.entryNodeTitle}
                        </span>
                        <span data-testid={'listId' + node.orderIndex} id={'listId' + node.orderIndex} onClick={handleChariotDown} ></span>
                        {<AiFillCaretDown className="FaAngleDown_rt pull-right" style={{ display: 'none' }} />}
                        {<AiFillCaretRight className="FaAngleRight_rt pull-right" />}
                    </span>
                }>
                <NavDropdown.Item href={localStorage.getItem("BASE_URL")} className="no-padding">
                    <span entryNodeFileRef={nestedNode.entryNodeFileRef} entryNodeIdRef={nestedNode.entryNodeIdRef} onClick={handleChapterSelection}>
                        {nestedNode}
                    </span>
                </NavDropdown.Item>
            </DropdownSubmenu>
        )
    }
    return (
        <NavDropdownMenu title="Contents" id="collasible-nav-dropdown">
            <div className="navBarScrollBlock">
                {
                    state.rootNodes !== undefined ? state.rootNodes.map(node => (NavTocNode(node))) : ""
                }
            </div>
        </NavDropdownMenu>
    )
}
export default withRouter(HierarchyNavMenu)
